import {Dispatch} from "redux";

import {createRequestActionTypes} from "../app/utils/request_response_utils/factories/create_request_action_types";
import {postRequest} from "../app/utils/request_response_utils/request";

/** Keep store action types out of Dashboard.tsx so homepage bundle does not pull AddCar/TinyMCE. */

export interface JwtPayloadData {
    data: {
        user_id: number | null;
        display_name: string | null;
    };
    message?: string;
}

export interface IUserData extends JwtPayloadData {
    id: number;
}

export const setDashboardUserOffersTypes = createRequestActionTypes({name: "setUserOffers", type: "GET", view: "Dashboard"});
export const setUserToStoreTypes = createRequestActionTypes({name: "setUserToStore", type: "GET", view: "Dashboard"});

export const getUserOffers = (authorId: number) => async (dispatch: Dispatch) => {
    return postRequest({}, "/api/cars-by-author", {author_id: authorId})
        .then((res: any) => {
            dispatch({type: setDashboardUserOffersTypes.success, result: res});

            return res;
        })
        .catch((err) => {
            console.warn("err on reset", err);
        });
};
